import axiosapi from "./axiosAPI";

// Get All Comments
export const getAllComments = async (
    setComments,
    setFetcherror,
    pkid,
    display,
    notification,
) => {
    
	try{
		const res =await axiosapi.get( display? `/comments?iid=${pkid} && display=${display}`:notification ? `/comments?iid=${pkid} && notification=${notification}`:`/comments?iid=${pkid}`);
        setComments(res.data.data ? res.data.data : {});
        console.log("FINAL DATA", res.data.data);
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Comments");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Comments");
		}
		
	}
	
};


export const getSpecificComments = async (
    setComments,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    isprocessed,
    isvalid,

) => {
    
    const page = ((event?.first)/(event?.rows))+1 || 1
    const limit = (event?.rows) || 10
    
    const options = {
        isprocessed,
        isvalid,
        page: page,
        limit:limit
    }
    
	try{
        const res = await axiosapi.post("/specificcomments", options);
        
        setComments(res.data.data ? res.data.data : {});
        setTotalCount(res.data.totalCount);
        setIsLoading(false);
        setFirst(event? event?.first:0);
        setRows(event? event?.rows:10)

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Comments");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Comments");
		}
		
	}
	
};

// Follow-ups table (paginated, includes incident snapshot + user)
export const getCommentsTable = async (
    setComments,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    searchTerm = ""
) => {
    const page = ((event?.first) / (event?.rows)) + 1 || 1;
    const limit = (event?.rows) || 10;
    const search = searchTerm || "";

    try {
        const res = await axiosapi.get("/comments/table", { params: { page, limit, search } });
        setComments(res?.data?.data?.rows || []);
        setTotalCount(res?.data?.data?.count || 0);
        setIsLoading(false);
        setFirst(event ? event?.first : 0);
        setRows(event ? event?.rows : 10);
    } catch (err) {
        if (err.response) {
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Comments");
        } else {
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Comments");
        }
        setIsLoading(false);
    }
};

export const exportCommentsTable = async (params, exportType = "pdf") => {
    const response = await axiosapi.get("/comments/table", {
        params: { ...params, exportReport: true, exportType },
        responseType: "blob"
    });

    const contentDisposition = response.headers["content-disposition"];
    let filename = `followups_${Date.now()}.${exportType}`;
    if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, "");
        }
    }

    const blob = new Blob([response.data], { type: response.headers["content-type"] });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

// Follow-ups report table (paginated with filters)
export const getFollowupsReportTable = async (
    setComments,
    setFetcherror,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    filters = {}
) => {
    const page = ((event?.first) / (event?.rows)) + 1 || 1;
    const limit = (event?.rows) || 10;

    try {
        const res = await axiosapi.get("/comments/table", {
            params: {
                page,
                limit,
                ...filters
            }
        });

        setComments(res?.data?.data?.rows || []);
        setTotalCount(res?.data?.data?.count || 0);
        setIsLoading(false);
        setFirst(event ? event?.first : 0);
        setRows(event ? event?.rows : 10);
    } catch (err) {
        if (err.response) {
            console.log(err.response);
            setFetcherror("Error: Could Not Fetch Comments");
        } else {
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Comments");
        }
        setIsLoading(false);
    }
};



// Get One Comment
export const getOneComment = async (
    pkid,
    setFetcherror,  
    setComment
    
)=>{
	try{
		const res =await axiosapi.get(`/comments/${pkid}`);
        setComment(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Comment");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Comment");
		}
		
	}
	
};


// Create New Comment
export const createComment = async (
    content,
    setContent,
    fromName,
    selectedStatus,
    setSelectedStatus,
    user_id,
    incident_id,
    setFetcherror,
    handleAllToasts,
    setComments,
    operatorinitiated

) => {


    if (!content || !fromName ||  !selectedStatus || !user_id || !incident_id ) {
        handleAllToasts(2, "No Comment Provided"); 
            return; 
        }

    const getOptions = () => { 
        if (operatorinitiated) { 
            return {
                content,
                fromname: fromName,
                status: selectedStatus?.name,
                user_id,
                incident_id,
                isvalid: true,
                isprocessed:true
            }
        } 
        return {
                content,
                fromname: fromName,
                status: selectedStatus?.name,
                user_id,
                incident_id
                 }
    }



    try{
        await axiosapi.post("/comments/",getOptions());
        setContent("");
        setSelectedStatus("");
        handleAllToasts(1, "Comment Created Successfully");
        getAllComments(setComments, setFetcherror,incident_id);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Comment");
            handleAllToasts(2, "Could Not update The Comment");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Comment");
            handleAllToasts(2, "Could Not update The Comment");
            
        }
        
    }
    
}


// Edit Existing Comment

export const editComment = async (
    commentpkid,
    fromName,
    user_id,
    incident_id,
    isvalid,
    isprocessed,
    setFetcherror,
    handleAllToasts,
    setComments,
    setIsLoading,
    setFirst,
    setRows,
    event,
    setTotalCount,
    setCommentValid,
    setViewDialogVisible,
    callback
              
        ) => {

            if (!commentpkid  || !(fromName || user_id || incident_id)) {
                handleAllToasts(2, "No Comment selected or item changed"); 
                    return;  
                }

            const PushItem = {

                    id:commentpkid,
                    isvalid,
                    isprocessed,
                };

            try{
                await axiosapi.patch("/comments/",PushItem );
                handleAllToasts(1, "Comment Updated Successfully");
                if (typeof callback === "function") callback(null, "Success");

                console.log("CLICKED HEEEEEEEEEE FYNCTION")
                setCommentValid(false);
                setViewDialogVisible(false);
                getSpecificComments  (
                        setComments,
                        setFetcherror,
                        setIsLoading,
                        setFirst,
                        setRows,
                        event,
                        setTotalCount,
                        false,
                        false
                    )
            }
            catch(err){
                    setFetcherror("Could Not Update Comment");
                    handleAllToasts(2, "Could Not Update Comment");
                    if (typeof callback === "function") callback(new Error("Could Not Update Comment"), null);
                    
                
            }
            
};



// Delete Existing Comment.

export const deleteComment = async (
    commentpkid,
    setComments,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/comments/${commentpkid}`);
        handleAllToasts(1, "Comment Deleted Successfully");
        getAllComments(setComments, setFetcherror);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Comment");
            handleAllToasts(2,"Error: Could Not Delete Comment");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Comment");
            handleAllToasts(2,"Error: Could Not Delete Comment");
		}
		
	}
	
};